import { hueOf, initialsOf } from '@wtfalch/design';

/**
 * A disc with two initials on a tint of a hue the seed hashes to --
 * `hueOf`/`initialsOf` are `@wtfalch/design`'s own (the same ones `Identity`
 * colours its own disc with), reused here rather than restated so a name
 * gets the same colour wherever Agora draws it. The disc itself is drawn
 * with the canvas's own `.av`/`.av-sm`, which `Identity`'s markup does not
 * produce.
 *
 * General across Mail and Chat: `seed` is whatever the section's own data
 * hashes stably on -- an email address in Mail, a Matrix user id in Chat.
 * Kept in `ui/` rather than `mail/` because both need exactly this, on two
 * different id shapes neither of which the other section imports.
 */
const STICKERS = ['peach', 'butter', 'mint', 'sky', 'lilac', 'rose'] as const;
/** Where each sticker sits on the hue wheel, so a hue lands on the nearest one. */
const STICKER_UPPER_HUE = [30, 75, 165, 255, 315, 360];

/** The `--st-*` pair for a hue: a tint and the ink that reads on it, both
 *  themed, where an `hsl()` built from the hue stays pale in a dark theme. */
export function stickerOf(hue: number): { background: string; color: string } {
  const h = ((hue % 360) + 360) % 360;
  const i = STICKER_UPPER_HUE.findIndex((upper) => h < upper);
  const name = STICKERS[i === -1 ? 0 : i];
  return { background: `var(--st-${name})`, color: `var(--st-${name}-ink)` };
}

export function Avatar({ name, seed, size }: { name?: string | null; seed: string; size?: 'sm' }) {
  const key = seed || '?';
  return (
    <span
      className={size === 'sm' ? 'av av-sm' : 'av'}
      style={stickerOf(hueOf(key))}
      aria-hidden="true"
    >
      {initialsOf(name ?? '', key)}
    </span>
  );
}
